import React from 'react';
import ReactDOM from 'react-dom/client';
import '../node_modules/bootstrap/dist/css/bootstrap.min.css';
import '../node_modules/bootstrap/dist/js/bootstrap.bundle';
import "./assets/sass/style.scss"
import { LanguageProvider } from './context/LanguageContext';
import AppRouter from './router/AppRouter';
import { BrowserRouter } from 'react-router-dom';
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <>
    <LanguageProvider>
      <BrowserRouter>
         <AppRouter/>
      </BrowserRouter>
    </LanguageProvider>
  </>
);

